(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    (function(){
    function init(){
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      document.querySelectorAll('[data-mega-cycle]').forEach(function(media){
        if (media.dataset.megaInit) return;
        var slides = media.querySelectorAll('.mega__feature-slide');
        if (slides.length < 2) return;
        media.dataset.megaInit = '1';
        var interval = parseInt(media.dataset.interval, 10) || 3200;
        var i = 0;
        setInterval(function(){
          slides[i].classList.remove('is-current');
          i = (i + 1) % slides.length;
          slides[i].classList.add('is-current');
        }, interval);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
